import { Box, Container, Grid, Tab, Tabs, Typography } from "@mui/material"
import styleCss from "../Style/style"
import { useState } from "react"
import LiveChart from "./Live-Chart";
import Complaints from "./Complaints";
import RefundTracker from "./RefundTracker";
import Help from "./Help-Faq";

const SupportCenter = () => {

    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <>
            <Grid sx={styleCss.CommonTopStyle}>
                <Container>
                    <Box sx={{
                        margin: '0 auto', width: '85%',
                        "@media (max-width:600px)": {
                            width: '100%',
                        },
                    }}>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '20px',
                                    fontWeight: 600,
                                    textAlign: 'left',
                                    color: '#1d1d1d',
                                }}>
                                    Support Center
                                </Typography>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '15px',
                                    fontWeight: 'normal',
                                    textAlign: 'left',
                                    color: '#364252',
                                    marginBottom: '30px',
                                    height: 'unset',
                                }}>
                                    We're here to help you 24/7
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 12, xs: 12 }}>
                                {/* Tabs */}
                                <Box
                                    sx={{
                                        bgcolor: "#f0f0f0",
                                        borderRadius: "30px",
                                        display: "block",
                                        padding: '6px 8px',
                                        height: "52px",
                                        "@media (max-width:600px)": {
                                            padding: '15px 8px',
                                            height: '225px',
                                        },
                                    }}
                                >
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        sx={{
                                            "& .MuiTabs-flexContainer": {
                                                borderRadius: "30px",
                                                flexDirection: "row",
                                                "@media (max-width:600px)": {
                                                    flexDirection: "column",
                                                    gap: "10px",
                                                },
                                            },
                                            "& .MuiTab-root": {
                                                textTransform: "none",
                                                borderRadius: "30px",
                                                minWidth: "150px",
                                                fontWeight: 600,
                                                color: "#364252",
                                                padding: "4px 8px",
                                                minHeight: "40px",
                                                fontFamily: "Segoe UI",
                                                fontSize: "14px",
                                                height: "40px",
                                                flex: 1,
                                                "@media (max-width:600px)": {
                                                    width: "100%",
                                                    minWidth: "auto",
                                                },
                                                "&.Mui-selected": {
                                                    bgcolor: "#fff",
                                                    color: "#364252",
                                                },
                                            },
                                            "& .MuiTabs-indicator": { display: "none" },
                                        }}
                                    >
                                        <Tab label="Help & FAQ" />
                                        <Tab label="Live Chat" />
                                        <Tab label="Complaints" />
                                        <Tab label="Refund Tracker" />
                                    </Tabs>
                                </Box>
                                <Box sx={{ marginTop: '25px' }}>
                                    {value === 0 && (
                                        <Box>
                                            <Help />
                                        </Box>
                                    )}
                                    {value === 1 && (
                                        <Box>
                                            <LiveChart />
                                        </Box>
                                    )}
                                    {value === 2 && (
                                        <Box>
                                            <Complaints />
                                        </Box>
                                    )}
                                    {value === 3 && (
                                        <Box>
                                            <RefundTracker />
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            </Grid>
        </>
    )
}
export default SupportCenter